import { createI18n, type VueMessageType } from 'vue-i18n'
import type { LocaleMessage } from '@intlify/core-base'

const localeFiles = import.meta.glob('@/locales/*.json', { eager: true })

function loadMessages() {
  type Messages = { [key: string]: LocaleMessage<VueMessageType> }

  const messages: Messages = {}

  Object.keys(localeFiles).forEach((key) => {
    const nameWithExtension = key.split('/').pop()
    if (nameWithExtension) {
      const name = nameWithExtension.replace(/\.\w+$/, '')
      messages[name] = (localeFiles[key] as any).default
    }
  })

  return messages
}

const i18n = createI18n({
  legacy: false,
  //WE CAN USE ENV VARS TO SET DEFAULT LOCALE AND FALLBACK LOCALE
  locale: 'es',
  fallbackLocale: 'es',
  globalInjection: true,
  messages: loadMessages()
})

export default i18n
